module.exports = __webpack_public_path__ + "static/img/right.b2d2310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/right.png
// module id = Bje8
// module chunks = 2